var todayDate = new Date();
var year = todayDate.getFullYear();
var month = ("0" + (todayDate.getMonth() + 1)).slice(-2);
var day = ("0" + todayDate.getDate()).slice(-2);
//adding a day
//day = ("0" + (todayDate.getDate() +1)).slice(-2);

console.log("year=" + year);
console.log("month=" + month);
console.log("day=" + day);

todayDate = new Date(year + "-" + month + "-" + day);
console.log("Bug 1 today Date=" + todayDate.toString());

//todayDate = new Date('2022-07-25');
todayDate.setHours(0, 0, 0, 0);

var accordionContentList = [
  {
    eventKey: "6",
    header: "National Women and Girls HIV/AIDS Awareness Day",
    defaultContent: "Check back for social media assets.",
    titleLeft: "Image Option 1",
    imageLeft: "/Gilead_NWGHAAD_1-display.png",
    imageMobileLeft: "/Gilead_NWGHAAD_1-display.png",
    imageAltLeft: "Women accounted for nearly 1 out of 5 new HIV diagnoses in the US in 2020",
    downloadLinkLeft: "/Gilead_NWGHAAD_1.png",
    downloadCaptionLeft: "Caption",
    downloadCaptionTextLeft:
      "NWGHAAD is an opportunity to honor the critical role women play in helping end the HIV epidemic. Share this graphic to help start the conversation about HIV and women in your community. #HIVAIDS #HIVAndWomen #HIVTesting #KnowYourStatus #StopHIVTogether #ThisIsWhatWeLiveFor",
    titleRight: "Image Option 2",
    imageRight: "/Gilead_NWGHAAD_2.png",
    imageMobileRight: "/Gilead_NWGHAAD_2.png",
    imageAltRight: "Only 10% of women, assigned female at birth and aged 16+, who could benefit from PrEP were prescribed PrEP in the US in 2019",
    downloadLinkRight: "/Gilead_NWGHAAD_2.png",
    downloadCaptionRight: "Caption",
    downloadCaptionTextRight:
      "#NWGHAAD is a day to share vital information about disparities in HIV that women and girls continue to face in prevention, awareness, and access to HIV care. Share this post to start a conversation. #HIVAIDS #HIVAndWomen #KnowYourStatus #StopHIVTogether #ThisIsWhatWeLiveFor ",
    scrollTo: "national-women",
    date: "2022-02-23",
    todayDate: todayDate,
    isActive: true,
    isEmpty: false,
    imageCount: 2
  },
  {
    eventKey: "5",
    header: "NATIONAL BLACK HIV/AIDS AWARENESS DAY",
    defaultContent: "Check back for social media assets.",
    titleLeft: "Image Option 1",
    imageLeft: "/Gilead_NBHAAD_1.png",
    imageMobileLeft: "/Gilead_NBHAAD_1.png",
    imageAltLeft: "Black Americans continue to be disproportionately impacted by HIV, according to 2022 CDC data.",
    downloadLinkLeft: "/Gilead_NBHAAD_1.png",
    downloadCaptionLeft: "Caption",
    downloadCaptionTextLeft:
      "Progress in HIV care has not been equally achieved. Share this post, raise awareness, and start a conversation about HIV today. #GileadHIV #HIVAwareness #HIV #AIDS #HIVAIDS #EndTheHIVEpidemic #HIVCare #NBHAAD #StopHIVTogether",
    titleRight: "Image Option 2",
    imageRight: "/Gilead_NBHAAD_2.png",
    imageMobileRight: "/Gilead_NBHAAD_2.png",
    imageAltRight: "Black Americans are approximately 8 times less likely to be on PrEP medicines than White Americans, according to 2022 CDC data.",
    downloadLinkRight: "/Gilead_NBHAAD_2.png",
    downloadCaptionRight: "Caption",
    downloadCaptionTextRight:
      "Of those who may benefit from PrEP, just 8% of Black Americans were prescribed PrEP in 2019 compared to 63% of White Americans. #GileadHIV #HIVAwareness #HIV #AIDS #HIVAIDS #EndTheHIVEpidemic #HIVCare #NBHAAD #StopHIVTogether",
    scrollTo: "national-black",
    date: "2022-05-23",
    todayDate: todayDate,
    isActive: true,
    isEmpty: false,
    imageCount: 2
  },
  {
    eventKey: "0",
    header: "National LATINX AIDS Awareness Day",
    defaultContent: "Check back for social media assets.",
    titleLeft: "Image Option 1",
    imageLeft: "/latinx-1-desktop.png",
    imageMobileLeft: "/latinx-1-mobile.png",
    imageAltLeft: "",
    downloadLinkLeft: "/Gilead_NLAAD_1.png",
    downloadCaptionLeft: "Caption",
    downloadCaptionTextLeft:
      " Poverty and language barriers, among other factors, may hinder access to HIV care for some Hispanic/Latino people. Share this post to drive awareness of this disparity and help bridge the gap. #HIVAIDS #HIVAwareness #EndTheHIVEpidemic #NLAAD #StopHIVTogether #ThisIsWhatWeLiveFor",
    titleRight: "Image Option 2",
    imageRight: "/latinx-2-desktop.png",
    imageMobileRight: "/latinx-2-mobile.png",
    imageAltRight: "",
    downloadLinkRight: "/Gilead_NLAAD_2.png",
    downloadCaptionRight: "Caption",
    downloadCaptionTextRight:
      "Although progress has been made, Hispanics/Latinos accounted for 29% of new HIV diagnoses despite making up only 18% of the US population in 2019. Share today to help address this disparity. #HIVAIDS #HIVAwareness #EndTheHIVEpidemic #NLAAD #StopHIVTogether #ThisIsWhatWeLiveFor",
    scrollTo: "transgender",
    date: "2022-10-15",
    todayDate: todayDate,
    isActive: true,
    isEmpty: false,
    imageCount: 2
  },
  {
    eventKey: "4",
    header: "World AIDS Day",
    defaultContent: "Check back for social media assets.",
    titleLeft: "Image Option 1",
    imageLeft: "/Gilead_worldaidsday_1.jpg",
    imageMobileLeft: "/Gilead_worldaidsday_1.jpg",
    imageAltLeft:
      "80% of new HIV infections in the US in 2018 were transmitted by people who didn’t know they had HIV or were not in care.",
    downloadLinkLeft: "/Gilead_worldaidsday_1.jpg",
    downloadCaptionLeft: "Caption",
    downloadCaptionTextLeft:
      "This World AIDS Day, we remember those lost to AIDS-related illnesses, and reengage people in care by prioritizing steps like HIV testing. Share to encourage action toward ending the HIV epidemic. #HIVAIDS #HIVAwareness #WorldAIDSDay #StopHIVTogether #ThisIsWhatWeLiveFor",
    titleRight: "Image Option 2",
    imageRight: "/Gilead_worldaidsday_2.jpg",
    imageMobileRight: "/Gilead_worldaidsday_2.jpg",
    imageAltRight:
      "Goals of the EHE Plan, 75% reduction in new HIV infections by 2025 and at least 90% reduction by 2030.",
    downloadLinkRight: "/Gilead_worldaidsday_2.jpg",
    downloadCaptionRight: "Caption",
    downloadCaptionTextRight:
      "The Ending the HIV Epidemic (EHE) sets a bold vision to end the HIV epidemic in the US by 2030. This World AIDS Day, we recommit to this whole-of-society initiative and to raising awareness about HIV/AIDS. #HIVAIDS #HIVAwareness #WorldAIDSDay #StopHIVTogether #ThisIsWhatWeLiveFor",
    scrollTo: "women",
    date: "2022-12-31",
    todayDate: todayDate,
    isActive: true,
    isEmpty: false,
    imageCount: 2
  },
  {
    eventKey: "1",
    header: "National HIV Testing Day",
    downloadCaptionTop: "Create a carousel post with all 3 of the images together.",
    defaultContent: "Check back for social media assets.",
    titleLeft: "Image 1",
    imageLeft: "/Gilead_NHTD23-1.png",
    imageAltLeft:
      "Today we acknowledge the critical need for HIV testing",
    imageMobileLeft: "/Gilead_NHTD23-1.png",
    downloadLinkLeft: "/Gilead_NHTD23-1.png",
    downloadCaptionLeft: "Caption",
    downloadCaptionTextLeft:
      " #HIVTestingDay is June 27. More than one option exists to get tested for HIV, from going to a clinic to an at-home test. And once you know your status, you can speak with a doctor about next steps. Get tested today. #KnowYourStatus #NHTD #StopHIVTogether #ThisIsWhatWeLiveFor",
      titleMiddle: "Image 2",
    imageMiddle: "/Gilead_NHTD23-2.png",
    imageMobileMiddle: "/Gilead_NHTD23-2.png",
    imageAltMiddle: "Per the CDC, there are approximately 1.2M people living with HIV in the US. About 13% are not aware of their status.",
    downloadLinkMiddle: "/Gilead_NHTD23-2.png",
    downloadCaptionMiddle: "Caption",
    downloadCaptionTextMiddle:
    "Progress in HIV care has not been equally achieved. Share this post, raise awareness, and start a conversation about HIV today. #GileadHIV #HIVAwareness #HIV #AIDS #HIVAIDS #EndTheHIVEpidemic #HIVCare #NBHAAD #StopHIVTogether",
    titleRight: "Image 3",
    imageRight: "/Gilead_NHTD23-3.png",
    imageMobileRight: "/Gilead_NHTD23-3.png",
    imageAltRight:
      "Per the CDC, nearly 40% of new HIV infections are transmitted by people who don't know they have the virus.",
    downloadLinkRight: "/Gilead_NHTD23-3.png",
    downloadCaptionRight: "Caption",
    downloadCaptionTextRight:
      "Testing rates have rebounded but are still 5% below pre–COVID-19 pandemic averages. #HIVTestingDay is June 27. Get tested for HIV, know your status, and speak with a doctor about next steps, no matter the results. #KnowYourStatus #NHTD #StopHIVTogether #ThisIsWhatWeLiveFor",
    scrollTo: "gay",
    date: "2033-06-24",
    todayDate: todayDate,
    isActive: true,
    isEmpty: false,
    imageCount: 3
  },
  {
    eventKey: "2",
    header: "Southern HIV/AIDS Awareness Day",
    defaultContent: "Check back for social media assets.",
    titleLeft: "Image Option 1",
    imageLeft: "/Gilead_SHAAD_1.png",
    imageMobileLeft: "/Gilead_SHAAD_1.png",
    imageAltLeft:
      "52% of HIV diagnoses in the United States occurred in the South in 2019.",
    downloadLinkLeft: "/Gilead_SHAAD_1.png",
    downloadCaptionLeft: "Caption",
    downloadCaptionTextLeft:
      "The South is the epicenter of the HIV epidemic in the US, yet access to HIV prevention services and care in the South is lacking. Raise awareness to help close the gaps. Share this post today. #ThisIsWhatWeLiveFor #HIVAIDS #HIVAwareness #EndTheHIVEpidemic #SHAAD #StopHIVTogether",
    titleRight: "Image Option 2",
    imageRight: "/Gilead_SHAAD_2.png",
    imageMobileRight: "/Gilead_SHAAD_2.png",
    imageAltRight:
      "~48% of the highestburden counties targeted by the Ending the HIV Epidemic (EHE) initiative are in the South, according to 2016 data.",
    downloadLinkRight: "/Gilead_SHAAD_2.png",
    downloadCaptionRight: "Caption",
    downloadCaptionTextRight:
      "Southern states bear the greatest burden of HIV. The EHE Initiative represents a commitment to helping address this disparity. Share this post to help raise awareness of HIV in the South. #ThisIsWhatWeLiveFor #HIVAIDS #HIVAwareness #EndTheHIVEpidemic #SHAAD #StopHIVTogether",
    scrollTo: "black",
    date: "2022-08-20",
    todayDate: todayDate,
    isActive: true,
    isEmpty: false,
    imageCount: 2
  },
  {
    eventKey: "3",
    header:
      'National Gay<br class="d-block d-md-none"/> Men\'s HIV/AIDS  <br class="d-block d-md-none"/>Awareness Day',
    defaultContent: "Check back for social media assets.",
    titleLeft: "Image Option 1",
    imageLeft: "/Gilead_NGMHAAD_1.png",
    imageMobileLeft: "/Gilead_NGMHAAD_1.png",
    imageAltLeft:
      "Based on 2010-2016 data, 1 in 6 gay and bisexual men in the United States may be diagnosed with HIV in their lifetime.",
    downloadLinkLeft: "/Gilead_NGMHAAD_1.png",
    downloadCaptionLeft: "Caption",
    downloadCaptionTextLeft:
      "HIV continues to disproportionately impact gay and bisexual men in the US. Help raise awareness. Share this post for National Gay Men's HIV/AIDS Awareness Day on September&nbsp;27. #ThisIsWhatWeLiveFor #HIVAIDS #HIVAwareness #EndTheHIVEpidemic #NGMHAAD #StopHIVTogether",
    titleRight: "Image Option 2",
    imageRight: "/Gilead_NGMHAAD_2.png",
    imageMobileRight: "/Gilead_NGMHAAD_2.png",
    imageAltRight:
      "New HIV infections in the United States among young gay and bisexual men aged 13-24 dropped 33% from 2015-2019.",
    downloadLinkRight: "/Gilead_NGMHAAD_2.png",
    downloadCaptionRight: "Caption",
    downloadCaptionTextRight:
      "Young gay & bisexual men continue to be impacted by HIV. The CDC recommends HIV testing every 3 to 6 months for men who have sex with men (MSM). Share this post to raise awareness of the impact of HIV. #ThisIsWhatWeLiveFor #HIVAIDS #EndTheHIVEpidemic #NGMHAAD #StopHIVTogether",
    scrollTo: "hispanic",
    date: "2022-09-30",
    todayDate: todayDate,
    isActive: true,
    isEmpty: false,
    imageCount: 2
  },
];

accordionContentList = accordionContentList.map(updateEvent);

function updateEvent(event) {
  event.date = new Date(event.date);
  event.date.setHours(0, 0, 0, 0);
  var eventTime = event.date.getTime();
  var todayTime = todayDate.getTime();

  if (eventTime < todayTime) {
    event.isActive = false;
    console.log("eventTime[" + event.date + "]=" + eventTime);
    console.log("todayTime[" + todayDate.toString() + "]=" + todayTime);
  }

  return event;

  //return eventTime < todayTime ? { ...event, isActive: false } : event;
}

/* console.log("today date=" + todayDate.toString());
console.log("todayDate.getTime()=" + todayDate.getTime());
console.log("");
console.log(""); */

var eventCounter = 5;
var eventCounterActive = 0;
for (var i = 0; i < accordionContentList.length; i++) {
  if (i == 0) {
    eventCounter = 0;
  }
  console.log(
    "[" +
      accordionContentList[i].date.toString() +
      ":isActive?]=" +
      accordionContentList[i].isActive
  );
  if (!accordionContentList[i].isActive) {
    var eventDate = new Date(accordionContentList[i].date);
    eventDate.setHours(24, 0, 0, 0);
    console.log("eventDate.getTime()=" + eventDate.getTime());
  }
  if (accordionContentList[i].date.getTime() < todayDate.getTime()) {
    accordionContentList[i].isActive = false;

    console.log(
      "[" +
        accordionContentList[i].date +
        "]=" +
        accordionContentList[i].date.toString()
    );
    console.log(
      "eventDate.getTime()=" + accordionContentList[i].date.getTime()
    );
    console.log("");
    accordionContentList[i].eventKey =
      "" + accordionContentList.length - eventCounter;
    eventCounter -= 1;
  } else {
    accordionContentList[i].eventKey = "" + eventCounterActive;
    eventCounterActive += 1;
  }
  console.log(
    "accordionContentList[" + i + "].header=" + accordionContentList[i].header
  );
  console.log(
    "accordionContentList[" +
      i +
      "].eventKey=" +
      accordionContentList[i].eventKey
  );
}

accordionContentList.sort((a, b) => new Date(a.date) - new Date(b.date));

export default accordionContentList;
